import { React, Fragment, PropTypes, reduxConnect } from '../lib/imports';

import { Spacing, Teaser } from '../components';
import { useCdnUrl, useCdnImage, getAssetSet } from '../app/context/config';
import { setSelectedAnswer, sendQuizAnswer } from './actions';
import TimsSkillTest from '../stq';
import { buildQuizView } from '../stq/platformQuestion';

const assetSet = (filename) => getAssetSet(useCdnImage, filename);

const QuizApp = ({
  hasError,
  errorText,
  gameLocked,
  lockedText,
  title,
  text,
  termsText,
  question,
  answerTitle,
  answerOptions,
  selectedAnswer,
  btnText,
  btnVarient,
  btnDisabled,
  handleQuizAnswerClick,
  handleQuizSubmission,
}) => {
  const cdnUrl = useCdnUrl();

  return (
    <>
      {!hasError ? (
        <Spacing top={!gameLocked} bottom={!gameLocked}>
          <TimsSkillTest
            gameLocked={gameLocked}
            lockedText={lockedText}
            assetUrl={cdnUrl}
            title={title}
            text={text}
            question={question}
            answerTitle={answerTitle}
            items={answerOptions}
            onSelect={handleQuizAnswerClick}
            selected={selectedAnswer}
            btnText={btnText}
            btnVarient={btnVarient}
            btnDisabled={btnDisabled}
            onSubmit={handleQuizSubmission}
            termsText={termsText}
          />
        </Spacing>
      ) : (
        <Spacing sides top bottom>
          <Teaser src={assetSet(['sticks'])} text={errorText} />
        </Spacing>
      )}
    </>
  );
};

QuizApp.propTypes = {
  hasError: PropTypes.bool,
  errorText: PropTypes.string,
  showNotificationBar: PropTypes.bool,
  notificationBarTitle: PropTypes.string,
  notificationBarText: PropTypes.string,
  gameLocked: PropTypes.bool,
  lockedText: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  question: PropTypes.array,
  answerTitle: PropTypes.string,
  answerOptions: PropTypes.array,
  selectedAnswer: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  termsText: PropTypes.string,
  btnText: PropTypes.string,
  btnVarient: PropTypes.string,
  btnDisabled: PropTypes.bool,
  handleQuizAnswerClick: PropTypes.func,
  handleQuizSubmission: PropTypes.func,
  handleNotificationBarCloseClick: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { config, strings, onboarding, ui } = state;
  const { notificationBarOpen } = ui;
  const { questions, attempts, selectedAnswer, correctAnswer, options, lockout, platformQuestion, useLegacyStq } =
    onboarding;

  const hasError = false;

  const showNotificationBar = attempts > 0 && !correctAnswer && notificationBarOpen;

  const notificationBarTitle = strings['notifications/quiz/wrongAnswer/title'];
  const notificationBarText = strings['notifications/quiz/wrongAnswer/text'];

  const view = buildQuizView({
    platformQuestion,
    questions,
    options,
    attempts,
    lockout,
    strings,
    useLegacyStq: !config.graphqlUrl || useLegacyStq,
  });

  const defaultProps = {
    config,
    gameLocked: view.gameLocked,
    title: view.title || strings['quiz/helpInfo/text'],
    text: view.text,
    answerTitle: strings['quiz/answerTitle/text'],
    termsText: strings['modals/tierSelection/terms/text'],
    question: view.question,
    answerOptions: view.answerOptions,
    selectedAnswer,
    btnText: strings['button/submitAnswer/text'],
    btnVarient: 'primary',
    btnDisabled: !selectedAnswer,
    lockedText: view.lockedText,
  };

  if (view.gameLocked) {
    return defaultProps;
  }

  return {
    ...defaultProps,
    showNotificationBar,
    notificationBarTitle,
    notificationBarText,
    hasError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleQuizAnswerClick: (id) => dispatch(setSelectedAnswer(id)),
    handleQuizSubmission: (answer) => dispatch(sendQuizAnswer(answer)),
  };
};

export default reduxConnect(mapStateToProps, mapDispatchToProps)(QuizApp);
